import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";
import "./ConfirmPopup.css";
import SvgSuccessSvg from "../../../../Components/IconComponents/SuccessSvg";
// import Loader from "../../../../Components/UiComponents/Loader/Loader";
import useLoading from "../../../../Hooks/useLoading";
import lmsToast from "../CustomToastifier/CustomToastifier";
import { useSelector } from "react-redux";
import SvgRedclosebutton from "../../../../Components/IconComponents/Redclosebutton";
import { ThemeContext } from "../../../..";
import DmsButton from "../DmsButton/DmsButton";
import { postDataWithBody } from "../../../../Services/Services";
import { CloseSopTask } from "../../../../Services/EndPoints";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ConfirmpopupSop = (props) => {
  const {
    titleValue,
    show,
    setshowConfirmPopup,
    taskData,
  } = props;
  
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  
  const handleToggle = () => {
    setshowConfirmPopup(false);
  };
  
  const handleCloseAction = async () => {
    try {
      setLoading(true);
      // Get user email from keycloak token
      const keycloak = window.keycloak || {};
      const userName = keycloak.idTokenParsed?.email || "system";
      
      const input = {
        sop_instance_id: taskData.id,
        user_name: userName,
      };

      const response = await postDataWithBody(CloseSopTask, input, {});
      
      if (response && response.status === "success") {
        toast.success("SOP instance closed successfully", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        navigate("../Sop-instance-list");
      } else {
        toast.error(response?.msg || "Failed to close SOP instance", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("Error closing SOP task:", error);
      toast.error("An error occurred while closing the SOP instance", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setLoading(false);
      setshowConfirmPopup(false);
    }
  };

  return (
    <>
      {/* <Loader show={loading} /> */}
      <div className="confirm__popup">
        <Modal
          show={show}
          id={theme}
          onHide={handleToggle}
          className="table__confirm--popup"
          dialogClassName="make-it-center"
          backdrop="static"
          keyboard={true}
          centered
        >
          <Modal.Header>
            <Modal.Title>
              {titleValue || "Close SOP Instance"}
            </Modal.Title>
            <SvgRedclosebutton
              onClick={handleToggle}
              className="cursor-pointer"
              width="1.5em"
              height="1.5em"
            />
          </Modal.Header>
          <Modal.Body>
            <div className="table_confirm_body">
              <div className="table_confirm_body_msg">
                Are you sure you want to close this SOP instance?
              </div>
            </div>
            <div className="table_confirm_button">
              <DmsButton
                label="Cancel"
                size="btn_sm"
                className="table__cancel"
                onClick={handleToggle}
                variant="secondary"
              />
              <DmsButton
                size="btn_sm"
                label="Yes"
                className="table__confirm"
                onClick={handleCloseAction}
              />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default ConfirmpopupSop;